export default __webpack_public_path__ + "static/media/attachment.127b65e5.svg";